export default "__VITE_ASSET__YsG_2Uow__"